import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import AppConfig from "../../config.js";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isValidToken, setIsValidToken] = useState(false);

  useEffect(() => {
    const jwtToken = localStorage.getItem("access_token");

    fetch(AppConfig.BACKEND_URL_REFATORADO+"jwt/validate-token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          setIsValidToken(true);
        } else {
          setIsValidToken(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao validar token:", error);
        setIsValidToken(false);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isValidToken ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;